import { render, staticRenderFns } from "./WebsiteAudit.vue?vue&type=template&id=18163fda&scoped=true"
import script from "./WebsiteAudit.vue?vue&type=script&lang=js"
export * from "./WebsiteAudit.vue?vue&type=script&lang=js"
import style0 from "./WebsiteAudit.vue?vue&type=style&index=0&id=18163fda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18163fda",
  null
  
)

export default component.exports